import { useEffect, useState } from "react";

import { IgAutocomplete, IgTextField } from "@intelligems/ig-theme";
import type { AutocompleteRenderInputParams } from "@mui/material";
import Stack from "@mui/material/Stack";
import { Panel } from "@src/features/experienceBuilder/modifications/common/panel/Panel";

import { InputProps } from "./types";

const sizes = [
  "10px",
  "11px",
  "12px",
  "13px",
  "14px",
  "16px",
  "18px",
  "20px",
  "24px",
  "32px",
  "48px",
  "64px",
];

export const FontSizeInput = ({ label, value, onChange }: InputProps) => {
  const [inputValue, setInputValue] = useState(value || "");

  useEffect(() => {
    setInputValue(value || "");
  }, [value]);

  const commit = (val: string) => {
    const normalized = val.match(/^\d+(\.\d+)?$/) ? `${val}px` : val;
    if (!/^\d+(\.\d+)?px$/.test(normalized)) {
      setInputValue(value || "");
      return;
    }
    onChange(normalized);
    setInputValue(normalized);
  };

  return (
    <Stack spacing={1}>
      <Panel.Label>{label}</Panel.Label>
      <IgAutocomplete
        freeSolo
        disableClearable
        filterOptions={(options: string[]) => options}
        options={sizes}
        inputValue={inputValue}
        onInputChange={(_e, newValue, reason) => {
          if (reason === "input") {
            setInputValue(newValue);
          } else if (reason === "reset") {
            setInputValue(newValue);
            commit(newValue);
          }
        }}
        onChange={(_e, newValue: string) => commit(newValue)}
        onBlur={() => {
          if (inputValue && inputValue !== value) {
            commit(inputValue);
          }
        }}
        onKeyDown={(e) => {
          if (e.key === "Enter" && inputValue) {
            commit(inputValue);
          }
        }}
        renderInput={(params: AutocompleteRenderInputParams) => (
          <IgTextField
            {...params}
            fullWidth
            size="small"
            placeholder="e.g. 16px"
          />
        )}
      />
    </Stack>
  );
};
